module.exports = "/images/vendor/flag-icon-css/flags/1x1/ax.svg?fdd00c438df18b3216076ae0e145673b";